<!-- Page de sélection des écrans lors de la création d'une campagne -->
<div class="scrollContainer" (scroll)="scrollParkContainer($event)">
    <wncm-internal-navigation
        (onPrevious)="goBack()"
        (onNext)="next()"
        [canSeePrevious]="false"
        [canSeeNext]="true"
        [canNext]="faceSelected.length > 0"
        [nextText]="nextText"
        [nextTextValid]="nextTextValid"
    ></wncm-internal-navigation>

    <button class="mainGoBackBtn" mat-flat-button outlined (click)="goBack()">
        <mat-icon> arrow_back_ios </mat-icon>
        Précédent
    </button>

    <h1 class="titleHeader">Choisissez les écrans de diffusion de ce spot</h1>

    <!-- MARK: Volet de filtres -->
    <app-shutter #filterChooseScreenShutter [name]="shutterName"></app-shutter>
    <div id="mobileFilter" class="fullFilterContainer">
        <wncm-screen-filter
            [shutterName]="shutterName"
            (filterParamsChange)="reloadFilter($event)"
            [filterParams]="faceFilter"
        >
        </wncm-screen-filter>

        <!-- MARK: Boutons de sélection -->

        <mat-checkbox class="selectAllChheck" color="primary" (change)="toggleCheckFaces($event)"> Tout sélectionner </mat-checkbox>

        <!-- <button mat-stroked-button color="primary" (click)="checkAllFaces()">
            <mat-icon>check_box</mat-icon>Tout sélectionner
        </button> -->
    </div>

    <!-- MARK: Liste des écrans -->
    @if (orgLocations) {
        <div>
            <!-- MARK: Liste des écrans -->
            <div
                class="mainLocationBaseContainer"
                #infiniteScrollParentElem
                infiniteScroll
                [infiniteScrollDistance]="2"
                [infiniteScrollThrottle]="100"
                (scrolled)="onScroll()"
                [scrollWindow]="true"
                (window:resize)="onResize($event)"
                [alwaysCallback]="true"
                [infiniteScrollContainer]="'.scrollContainer'"
                [fromRoot]="true"
            >
                @if (loader) {
                    <mat-spinner [diameter]="70" style="margin: auto; margin-top: 70px"></mat-spinner>
                } @else {
                    @if (orgLocations?.length <= 0) {
                        <p class="w-title noResult">Pas d'écran correspondant</p>
                    }
                }

                <!-- Liste des Enseignes -->
                @for (org of orgLocations; track $index) {
                    <div class="screenListContainer">
                        <!-- MARK: Liste des faces -->
                        @for (face of org.l; track $index) {
                            <div
                                class="screenContainer"
                                (click)="processFace(face)"
                                [ngClass]="{
                                    active: faceIsSelected(face.i),
                                    uncompatible: face.e != true,
                                }"
                            >
                                <div>
                                    <!-- @if (faceIsSelected(face.i)) {
                                        <div class="selectedContainer">
                                            <span class="material-icons"> done </span>
                                        </div>
                                    } -->

                                    @if (face.e != true) {
                                        <div class="notCompatibleMentionContainer">
                                            <span class="notCompatibleMention">Ecran non compatible</span>
                                            <div class="criteriaChips">
                                                <span class="invalid">
                                                    <p>Format Incompatible</p>
                                                </span>
                                            </div>
                                        </div>
                                    }
                                    <!-- Avoir une image chouette lorsqu'il manque une image à l'écran a afficher si face.i == null -->
                                    @if (face.t != null) {
                                        <div class="screenImg" alt="Image écran" [style]="getFaceBgUrl(face)"></div>
                                    } @else {
                                        <!-- IF no IMG -->
                                        <div class="screenImg noContent">
                                            <div class="gradientLayer"></div>
                                            <span>Dispositif sans photo</span>
                                        </div>
                                    }
                                    <div class="infoContainer">
                                        <!-- MARK: Infos de la face -->
                                        <div class="faceInfos">
                                            <!-- ScreenCode -->
                                            <div class="screenCodeContainer">
                                                <span class="screenCode">Ecran </span>
                                                <!-- Nom Wanview en premier -->
                                                @if (face?.fnw != null) {
                                                    <span class="screenCode">{{ face.fnw }} - </span>
                                                }
                                                <span class="screenCode">{{ face.sc }}</span>
                                            </div>

                                            <!-- Tags de la face -->
                                            @if (org.k !== 'Wancom') {
                                                <span class="faceTags">
                                                    @for (tag of face.ts; track $index) {
                                                        <span
                                                            [ngClass]="{
                                                                tagItem: true,
                                                                selected: tagIsSelected(tag.id),
                                                            }"
                                                        >
                                                            @if (getTagIcon(tag.i) != null) {
                                                                <mat-icon class="chipCatIcon">
                                                                    {{ getTagIcon(tag.i) }}
                                                                </mat-icon>
                                                            }
                                                            {{ tag.n }}
                                                        </span>
                                                    }
                                                </span>
                                            } @else {
                                                <div style="display: flex">
                                                    <mat-icon color="primary">place</mat-icon>
                                                    <div class="addressName">
                                                        <span>{{ face.sa }}</span>
                                                        <br />
                                                        <span>{{ face.cz }} {{ face.cn }}</span>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div class="selectorContainer">
                                    <p class="selectText">
                                        <ng-container *ngIf="!faceIsSelected(face.i) && face.e == true">
                                            <div class="Txt">
                                                <mat-icon matSuffix style="cursor: pointer"> add </mat-icon>
                                                <span>Sélectionner</span>
                                            </div>
                                        </ng-container>
                                        <ng-container *ngIf="faceIsSelected(face.i) && face.e == true">
                                            <div class="Txt selectedTxt">
                                                <mat-icon matSuffix style="cursor: pointer"> done </mat-icon>
                                                <span>Sélectionné</span>
                                            </div>
                                        </ng-container>
                                    </p>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    } @else {
        <div class="spinnerContainer">
            <mat-spinner class="crud-edit-loading"></mat-spinner>
        </div>
    }
</div>
